// src/belediye/utils/activeUnit.js
//
// FAZ-22 — Aktif birim çözümleyici (canonical route temeli).
//
// URL param'a BAĞIMSIZ: `scope.mode` + `localStorage.activeUnitSlug` + `units`'ten
// aktif birimi çözer. Böylece birimsiz canonical rotalar (/yonetim/dashboard vb.)
// kabuk/sidebar/href için aynı birimi URL olmadan üretebilir.
//
// Backend birimi zaten `X-Unit-Slug` header'ından (kaynak: localStorage) alır;
// bu util yalnız FRONTEND sunumu içindir — güvenlik değil.
//
// Reserved slug'lar birim DEĞİLDİR (kabuk kimlikleri) → birim olarak çözülmez.

const RESERVED = ["baskanlik", "birim-sec", "halk-masasi", "sistem", "saha"];

export function resolveActiveUnit({ scopeMode, activeUnitSlug, units } = {}) {
  const list = Array.isArray(units) ? units : [];

  // all_units (başkan / genel_admin) → başkanlık kabuğu; birim gerektirmez.
  if (scopeMode === "all_units") {
    return { unitSlug: "baskanlik", unitId: null, unitName: "Başkanlık", isAllUnits: true, needsSelection: false };
  }

  // localStorage'daki aktif slug (reserved değilse) → onu kullan;
  // yoksa tek üyelikte o birimi otomatik seç.
  const usableStored = activeUnitSlug && !RESERVED.includes(activeUnitSlug) ? activeUnitSlug : "";
  const slug = usableStored || (list.length === 1 ? list[0].unit_slug : "");

  if (!slug) {
    return {
      unitSlug: "", unitId: null, unitName: "", isAllUnits: false,
      needsSelection: list.length >= 2,
    };
  }

  const found = list.find((u) => u.unit_slug === slug) || null;
  return {
    unitSlug: slug,
    unitId: found ? found.unit_id : null,
    unitName: found ? found.unit_name : "",
    isAllUnits: false,
    needsSelection: false,
  };
}
